import api from '../api';

import CrmSyncActions from 'actions/crm/CrmSyncActions';

/** CrmSyncAccountsAndOpportunitiesPrefixSearchSource implements interactions with account-and-opportunities-prefix-search endpoints */
const CrmSyncAccountsAndOpportunitiesPrefixSearchSource = {
  searchPrefix: {
    remote(state, prefix) {
      const config = {baseURL: '/apiv2/crm'};
      const data = {prefix: prefix};
      return api.post(`/search_accounts_and_opportunities`, data, config);
    },
    loading: CrmSyncActions.prefixSearchAccountsAndOpportunitiesLoading,
    success: CrmSyncActions.prefixSearchAccountsAndOpportunitiesSuccess,
    error: CrmSyncActions.prefixSearchAccountsAndOpportunitiesError,
  },
};

export default CrmSyncAccountsAndOpportunitiesPrefixSearchSource;
